<!-- eslint-disable vue/max-len -->
<template>
  <svg
    :class="`color-stroke-${color}`"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      stroke-width="2"
    />
    <path d="M3 8.66675L21 8.66675" stroke-width="2" />
    <path d="M3 14.5L21 14.5" stroke-width="2" />
    <path
      d="M15.1667 12C15.1667 14.6624 14.7152 17.0258 14.0232 18.6865C13.6764 19.5189 13.2888 20.1274 12.9095 20.5124C12.5337 20.8938 12.227 21 12 21C11.7731 21 11.4664 20.8938 11.0906 20.5124C10.7113 20.1274 10.3237 19.5189 9.97684 18.6865C9.28491 17.0258 8.83337 14.6624 8.83337 12C8.83337 9.33761 9.28491 6.97417 9.97684 5.31355C10.3237 4.48105 10.7113 3.87264 11.0906 3.48763C11.4664 3.10615 11.7731 3 12 3C12.227 3 12.5337 3.10615 12.9095 3.48763C13.2888 3.87264 13.6764 4.48105 14.0232 5.31355C14.7152 6.97417 15.1667 9.33761 15.1667 12Z"
      stroke-width="2"
    />
  </svg>
</template>

<script setup lang="ts">
interface icon {
  color?: string;
}

withDefaults(defineProps<icon>(), {
  color: 'black',
});
</script>
